import React, { useEffect, useState } from 'react';
import EditTrip from './MainFunctions/EditTrip';
import logo from './Components/logo.png';
import ShowTrip from './MainFunctions/ShowTrip';
import uuid from 'react-uuid';
import Route from './Definitions/Route';

/**
 * Load settings stored in localstorage
 * @returns settings object
 */
function loadData() {
	let settings = JSON.parse(localStorage.getItem("sl-hem") || '{"routes":[]}');
	for (let i = 0; i < settings.routes.length; i++) {
		if (settings.routes[i].numResult === undefined)
			settings.routes[i].numResult = "5";
		if (settings.routes[i].numResult === "1")
			settings.routes[i].numResult = "2";
	}
	settings.reverse = settings.reverse ? true : false;
	return settings;
}

/**
 * Save settings in localStorage
 * @param data : settings struct
 */
function saveData(data: any): void {
	localStorage.setItem("sl-hem", JSON.stringify(data));
}

/**
 * Main App
 * @returns JSX.Element
 */
const MainApp = (): JSX.Element => {
	const [settings, setSettings] = useState(loadData());
	const [showAddRoute, setShowAddRoute] = useState(false);
	const [coords, setCoords] = useState({} as any);

	const setPosition = (position: any) => {
		setCoords(position.coords);
	}

	// Save route in localstorage
	const saveRoute = (nr: number, route: Route) => {
		if (nr < 0)
			settings.routes.unshift(route);
		else
			settings.routes[nr] = route;
		saveData(settings);
		setSettings({ ...settings });
		setShowAddRoute(false);
	}

	// Delete route in localstorage
	const deleteRoute = (index: number) => {
		settings.routes.splice(index, 1);
		saveData(settings);
		setSettings({ ...settings });
	}

	// Reverse direction or routes
	const flip = () => {
		settings.reverse = !settings.reverse;
		saveData(settings);
		setSettings({ ...settings });
	}

	// Toggle visibility of one route
	const toggleVisible = (nr: number) => {
		settings.routes[nr].hidden = !settings.routes[nr].hidden;
		saveData(settings);
		setSettings({ ...settings });
	}

	const flipShowAddRoute = () => setShowAddRoute(!showAddRoute);

	if (coords.latitude === undefined && navigator.geolocation) {
		for (let i = 0; i < settings.routes?.length; i++) {
			if (settings.routes[i].useCoords) {
				navigator.geolocation.getCurrentPosition(setPosition);
				break;
			}
		}
	}

	// Create an ID for logging if not defined
	if (settings.id === undefined) {
		settings.id = Date.now() + "_" + uuid();
		saveData(settings);
		setSettings({ ...settings });
	}

	// Log usage
	useEffect(() => {
		let url = "/stat.cgi?id=" + settings.id +
			"&log=hem" +
			"&data=len:" + settings.routes?.length;
		fetch(url);
	}, [settings]);

	/* Full layout */
	return (
		<div>
			{settings?.routes?.length ?
				<>
					<button
						className='actionbutton'
						onClick={flip}>
						{settings.reverse ? <>⇩</> : <>⇧</>}
						Byt färdriktning
					</button>
					<button
						className='actionbutton'
						onClick={() => { window.location.reload(); }}>
						&#x21bb;
						Uppdatera
						{settings?.routes?.length > 1 ? <>&nbsp;alla</> : <></>}
					</button>
					<button
						className='actionbutton'
						onClick={flipShowAddRoute}>
						+
						Ny rutt
					</button>
					{showAddRoute ?
						<>
							<hr />
							<EditTrip
								cbSave={saveRoute}
								cbCancel={flipShowAddRoute}
								routes={settings?.routes}
								reverse={settings.reverse}
								id={-1}
							/>
						</>
						: <></>
					}
				</>
				:
				<>
					<h1>
						<img
							src={logo}
							alt={"logo"}
							height={"64px"} />
						&nbsp;
						Åk hem</h1>
					<p>Det här är en enkel hjälp för att lägga upp dina normala
						resor och få en resevisning från aktuell tid.
						Jag använder det för att snabbt veta när nästa tåg hem går.
					</p>
					<p>
						Lägg till en vanlig resa du gör i fälten ovan och du fattar galoppen.
						Lycka till.
					</p>

					<EditTrip
						cbSave={saveRoute}
						routes={settings?.routes}
						reverse={settings.reverse}
						id={-1}
					/>
				</>
			}
			{/* All routes */}
			{settings?.routes?.map((item: any, idx: number) =>
				<React.Fragment key={idx}>
					<hr />
					<div
						style={{ backgroundColor: ["#444", "#222"][idx & 1] }}
					>
						<ShowTrip
							key={item.start.id + item.end.id + ((idx + 1) * (settings.reverse ? 1 : 2)) * (item.useCoords && coords.latitude === undefined ? -1 : 1)}
							reverse={settings.reverse}
							coords={coords}
							hidden={item.hidden}
							cbToggleVisible={toggleVisible}
							cbSaveRoute={saveRoute}
							cbDeleteRoute={deleteRoute}
							routes={settings.routes}
							id={idx}
						/>
					</div>
				</React.Fragment>
			)}
		</div>
	);
};

export default MainApp;